export default "/assets/modules/images/MyICSC-Complete.svg?108f93a213a6c60d811f954128dacead";